import { CORE_SERVER_HOST } from '@src/config';
import { getDefaultAxiosInstance } from '.';

interface SalesRecordDto {
  id: number;
  platform: string;
  store: string;
  saleDate: string;
  amount: number;
  netAmount: number | null;
  commission: number | null;
  count: number | null;
}

interface DailySalesTotalDto {
  saleDate: string;
  totalAmount: number;
  totalNetAmount: number;
  totalCount: number;
  records: SalesRecordDto[];
}

interface StoreSalesDto {
  store: string;
  totalAmount: number;
  totalNetAmount: number;
  totalCount: number;
}

interface PlatformSalesDto {
  platform: string;
  totalAmount: number;
  totalNetAmount: number;
  totalCount: number;
}

export interface SalesSummaryDto {
  startDate: string;
  endDate: string;
  totalAmount: number;
  totalNetAmount: number;
  totalCount: number;
  byStore: StoreSalesDto[];
  byPlatform: PlatformSalesDto[];
  daily: DailySalesTotalDto[];
}

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export async function getSalesSummary(params: {
  startDate: string;
  endDate: string;
  store?: string;
  platform?: string;
}) {
  const axiosInstance = getDefaultAxiosInstance();
  const { data } = await axiosInstance.get<ApiResponse<SalesSummaryDto>>(
    `https://${CORE_SERVER_HOST}/manage/sales/summary`,
    { params }
  );
  return data.data;
}
